var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.601 7.10104C23.933 6.7691 23.933 6.2309 23.601 5.89896L18.1917 0.489592C17.8597 0.157647 17.3215 0.157647 16.9896 0.489592C16.6576 0.821538 16.6576 1.35973 16.9896 1.69167L21.7979 6.5L16.9896 11.3083C16.6576 11.6403 16.6576 12.1785 16.9896 12.5104C17.3215 12.8424 17.8597 12.8424 18.1917 12.5104L23.601 7.10104ZM1 5.65C0.53056 5.65 0.150002 6.03056 0.150002 6.5C0.150002 6.96944 0.53056 7.35 1 7.35V5.65ZM23 5.65L1 5.65V7.35L23 7.35V5.65Z","fill":"currentColor"}));
}

ArrowIcon.defaultProps = {"width":"24","height":"13","viewBox":"0 0 24 13","fill":"none"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
